// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

// normalizers
import bookingEstimateParseData from "./parseData";

const bookingEstimateParseResponse = ({ rawResponse }) => {
  return {
    data: bookingEstimateParseData({
      rawResponseData: get(rawResponse, "data"),
    }),
  };
};

export default bookingEstimateParseResponse;
